import React, { useState } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import { Constant } from "../helper/Constants";

const CONTACT_BANNER =
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f";

export default function ContactUs() {
  const [activeModal, setActiveModal] = useState(null);

  return (
    <>
      <Header />

      {/* ================= TOP BANNER ================= */}
      <div
        style={{
          width: "100%",
          height: 340,
          backgroundImage: `url(${CONTACT_BANNER})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
          }}
        />
        <div
          style={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            alignItems: "center",
            padding: "0 8%",
            color: "#fff",
          }}
        >
          <h1 style={{ fontSize: 44, fontWeight: 700 }}>Contact Us</h1>
        </div>
      </div>

      {/* ================= CONTACT INFO + MAP ================= */}
      <div
        style={{
          padding: "70px 8%",
          display: "flex",
          gap: "6%",
          flexWrap: "wrap",
        }}
      >
        {/* LEFT : CONTACT INFO */}
        <div style={{ width: "44%", minWidth: 320 }}>
          <h2 style={{ fontSize: 36, marginBottom: 10 }}>
            CONTACT <span style={{ color: "#ff6f6f" }}>INFO</span>
          </h2>

          <p style={{ fontSize: 18, color: "#555", marginBottom: 30 }}>
            Welcome to VASA-Abacus. We are glad to have you around.
          </p>

  
          <ContactItem
            icon="✉️"
            title="Email"
            value="sapnachopde1975@gmail.com"
          />
          <ContactItem
            icon="✉️"
            title="Email"
            value="vasaicompdigilearn@gmail.com"
          />

          <ContactItem icon="📞" title="Phone" value="9422690015" />
          <ContactItem icon="📞" title="Phone" value="9423110012" />

          <ContactItem
            icon="📍"
            title="Address"
            value="Shila Complex Nearby, Amravati Road, Wadi, Nagpur, Maharashtra - 440023"
          />
        </div>

        {/* RIGHT : MAP (UPDATED ADDRESS) */}
        <div style={{ width: "50%", minWidth: 320 }}>
          <h2 style={{ fontSize: 36, marginBottom: 15 }}>
            FIND US <span style={{ color: "#ff6f6f" }}>ON MAP</span>
          </h2>

          <iframe
            title="VASA ICOMP Digilearn - Nagpur"
            src="https://www.google.com/maps?q=Shila%20Complex%20Nearby%2C%20Amravati%20Road%2C%20Wadi%2C%20Nagpur%2C%20Maharashtra%20440023&output=embed"
            width="100%"
            height="430"
            style={{ border: 0, borderRadius: 10 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      {/* ================= BUTTON STRIP ================= */}
      <div
        style={{
          background: "#777",
          padding: "40px 20px",
          textAlign: "center",
        }}
      >
        <h3 style={{ color: "#fff", fontSize: 22 }}>
          We are the best Abacus Training Centre. Contact us.
        </h3>

        <div
          style={{
            marginTop: 25,
            display: "flex",
            gap: 16,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Btn color="#e91e63" onClick={() => setActiveModal("franchise")}>
            Franchisee Inquiry
          </Btn>

          <Btn color="#ff9800" onClick={() => setActiveModal("demo")}>
            Student Inquiry
          </Btn>

          <Btn color="#8bc34a">Career Inquiry</Btn>

          <Btn color="#00bcd4" onClick={() => setActiveModal("school")}>
            School Inquiry
          </Btn>
        </div>
      </div>

      {/* ================= MODALS ================= */}
      {activeModal === "demo" && (
        <RequestDemoModal onClose={() => setActiveModal(null)} />
      )}
      {activeModal === "franchise" && (
        <FranchiseModal onClose={() => setActiveModal(null)} />
      )}
      {activeModal === "school" && (
        <SchoolEnquiryModal onClose={() => setActiveModal(null)} />
      )}

      <Footer />
    </>
  );
}

/* ================= CONTACT ITEM ================= */

const ContactItem = ({ icon, title, value }) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: 15,
      marginBottom: 22,
    }}
  >
    <div
      style={{
        fontSize: 28,
        background: "#fff2ec",
        color: "#ff6f6f",
        width: 48,
        height: 48,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {icon}
    </div>

    <div>
      <div style={{ fontSize: 16, fontWeight: 600, color: "#333" }}>
        {title}
      </div>
      <div style={{ fontSize: 18, color: "#555", lineHeight: 1.5 }}>
        {value}
      </div>
    </div>
  </div>
);

const Btn = ({ children, color, onClick }) => (
  <button
    onClick={onClick}
    style={{
      padding: "13px 24px",
      background: color,
      color: "#fff",
      border: "none",
      borderRadius: 5,
      cursor: "pointer",
      fontSize: 15,
      fontWeight: 600,
    }}
  >
    {children}
  </button>
);

/* ================= MODALS ================= */

function RequestDemoModal({ onClose }) {
  const [form, setForm] = useState({
    student_name: "",
    guardian_name: "",
    email: "",
    contact: "",
    age: "",
    date: "",
  });

  const submit = async () => {
    await axios.post(Constant.postUrls.createDemo, form);
    alert("Demo request submitted!");
    onClose();
  };

  return (
    <Modal title="Book Free Demo" onClose={onClose}>
      {Object.keys(form).map((k) => (
        <input
          key={k}
          placeholder={k.replace("_", " ").toUpperCase()}
          value={form[k]}
          onChange={(e) => setForm({ ...form, [k]: e.target.value })}
          style={input}
        />
      ))}
      <button onClick={submit} style={submitBtn}>Submit</button>
    </Modal>
  );
}

function FranchiseModal({ onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    message: "",
  });

  const submit = async () => {
    await axios.post(Constant.postUrls.submitFranchiseEnquiry, form);
    alert("Franchise enquiry submitted!");
    onClose();
  };

  return (
    <Modal title="Franchise Enquiry" onClose={onClose}>
      {Object.keys(form).map((k) => (
        <input
          key={k}
          placeholder={k.toUpperCase()}
          value={form[k]}
          onChange={(e) => setForm({ ...form, [k]: e.target.value })}
          style={input}
        />
      ))}
      <button onClick={submit} style={submitBtn}>Submit</button>
    </Modal>
  );
}

function SchoolEnquiryModal({ onClose }) {
  const [form, setForm] = useState({
    contact_person_name: "",
    email: "",
    phone: "",
    school_name: "",
    position: "",
    message: "",
  });

  const submit = async () => {
    await axios.post(Constant.postUrls.schoolEnquiry, form);
    alert("School enquiry submitted!");
    onClose();
  };

  return (
    <Modal title="School Enquiry" onClose={onClose}>
      {Object.keys(form).map((k) => (
        <input
          key={k}
          placeholder={k.replace("_", " ").toUpperCase()}
          value={form[k]}
          onChange={(e) => setForm({ ...form, [k]: e.target.value })}
          style={input}
        />
      ))}
      <button onClick={submit} style={submitBtn}>Submit</button>
    </Modal>
  );
}

/* ================= GENERIC MODAL ================= */

function Modal({ title, children, onClose }) {
  return (
    <div style={overlay}>
      <div style={modal}>
        <span style={close} onClick={onClose}>×</span>
        <h3 style={{ marginBottom: 15 }}>{title}</h3>
        {children}
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const modal = {
  width: 420,
  background: "#fff",
  padding: 30,
  borderRadius: 6,
  position: "relative",
};

const close = {
  position: "absolute",
  top: 10,
  right: 14,
  fontSize: 22,
  cursor: "pointer",
};

const input = {
  width: "100%",
  padding: 10,
  marginBottom: 10,
  borderRadius: 4,
  border: "1px solid #ccc",
};

const submitBtn = {
  width: "100%",
  padding: 12,
  background: "#ff6f6f",
  color: "#fff",
  border: "none",
  borderRadius: 4,
  cursor: "pointer",
};
